import {RateBreakdown} from '@findhotel/sapi'

// eslint-disable-next-line no-restricted-imports
import {calculateTotalRate} from './calculateTotalRate'

const discountPercentage = 0.02
const discountMinPrice = 10.0

/**
 * Determines if a split booking price is eligible based on rate comparison.
 * @param splitBookingTotalRate - The rate breakdown for split booking
 * @param cheapestOfferTotalRate - The total rate of the cheapest offer
 * @returns True if split booking price is eligible, false otherwise
 */
export const isSplitBookingPriceEligible = (
  splitBookingTotalRate: RateBreakdown | undefined,
  cheapestOfferTotalRate: number
): boolean => {
  if (!cheapestOfferTotalRate) {
    return true
  }

  if (!splitBookingTotalRate) {
    return false
  }

  const splitBookingOfferTotalRate = calculateTotalRate(
    splitBookingTotalRate,
    true,
    true
  )

  const minDiscount = Math.max(
    discountPercentage * cheapestOfferTotalRate,
    discountMinPrice
  )

  return splitBookingOfferTotalRate < cheapestOfferTotalRate - minDiscount
}
